import { translation } from '@cue/translations';

export enum ResourceAttendeeStatus {
  Declined = 'rejected',
  Confirmed = 'confirmed',
  NeedConfirmation = 'need-confirmation',
  ConfirmNow = 'confirm-now',
  Unconfirmed = 'unconfirmed',
  ReleaseFailed = 'release-failed',
  ReleasedForNonConfirmation = 'released',
  Accepted = 'accepted',
  Tentative = 'tentative',
}

export type EventStatusFilterState = {
  text: string;
  id: number;
  value: {
    status: ResourceAttendeeStatus;
    color: string;
    class: string;
  };
};

export type OrderEventStatus = ResourceAttendeeStatus | 'cancelled';

export type OrderEventStatusFilterState = Omit<EventStatusFilterState, 'value'> & {
  value: Omit<EventStatusFilterState['value'], 'status'> & {
    status: OrderEventStatus;
  };
};

export const EVENT_STATUSES: EventStatusFilterState[] = [
  {
    text: translation.common.accepted,
    id: 2,
    value: {
      status: ResourceAttendeeStatus.Accepted,
      color: '#33b630',
      class: 'accepted',
    },
  },
  {
    text: translation.common.tentative,
    id: 3,
    value: {
      status: ResourceAttendeeStatus.Tentative,
      color: '#ea8f08',
      class: 'tentative',
    },
  },
  {
    text: translation.common.declined,
    id: 4,
    value: {
      status: ResourceAttendeeStatus.Declined,
      color: '#ce2828',
      class: 'rejected',
    },
  },
  {
    text: translation.common.confirmed,
    id: 5,
    value: {
      status: ResourceAttendeeStatus.Confirmed,
      color: '#ce2828',
      class: 'confirmed',
    },
  },
  {
    text: translation.common.released,
    id: 6,
    value: {
      status: ResourceAttendeeStatus.ReleasedForNonConfirmation,
      color: '#ce2828',
      class: 'released',
    },
  },
  {
    text: translation.common.needConfirmation,
    id: 7,
    value: {
      status: ResourceAttendeeStatus.NeedConfirmation,
      color: '#ce2828',
      class: 'need-confirmation',
    },
  },
  {
    text: translation.common.unconfirmed,
    id: 8,
    value: {
      status: ResourceAttendeeStatus.Unconfirmed,
      color: '#ce2828',
      class: 'unconfirmed',
    },
  },
  {
    text: translation.common.confirmNow,
    id: 9,
    value: {
      status: ResourceAttendeeStatus.ConfirmNow,
      color: '#ce2828',
      class: 'confirm-now',
    },
  },
  {
    text: translation.common.releaseFailed,
    id: 10,
    value: {
      status: ResourceAttendeeStatus.ReleaseFailed,
      color: '#ce2828',
      class: 'released',
    },
  },
];

export const ORDER_EVENT_STATUSES: OrderEventStatusFilterState[] = [
  ...EVENT_STATUSES,
  {
    text: translation.common.cancelled,
    id: 1,
    value: {
      status: 'cancelled',
      color: '#ce2828',
      class: 'cancelled',
    },
  },
];
